import { HeroCarouselMedias, ProductMedias } from '../../../../types/interfaces';

import { TransformerFactory } from './TransformerFactory';

export function buildHeroCarouselMedias(productMedias: ProductMedias): HeroCarouselMedias {
  const transformer = TransformerFactory.getTransformer(productMedias);
  const transformedScenes = transformer.transformProductPageMedias(productMedias);
  return transformedScenes;
}
